import React from 'react';
import Head from '../../Head';
import {
  Benefits,
  GoalsInfo,
  GoogleReviews,
  Hero,
  Infography,
  Press,
  Resume,
  Sponsors,
} from '../Components';
import { Box } from '../../SimpleUI';
import { useCountry } from '../../../contexts/CountryContext';

const NewHome = () => {
  const { countryPrefix } = useCountry();

  const isAr = countryPrefix === '/ar';

  const pageTitle = 'Descubrí nuestros proyectos de inversión en real estate';
  const pageDescription =
    '¿Querés invertir en Real Estate? Encontrá una amplia variedad de proyectos inmobiliarios en Simplestate. Contamos con inversiones a medida para vos. Ingresá ahora.';

  return (
    <Head title={pageTitle} description={pageDescription}>
      <Hero />
      <Benefits />
      <Box
        height={{ mobile: isAr ? '150px' : '250px', desktop: '100px' }}
        backgroundColor="white"
      ></Box>
      {isAr && <GoalsInfo />}
      <Resume />
      <Infography />
      <Sponsors />
      <Box
        height={{ mobile: '50px', desktop: '80px' }}
        backgroundColor="white"
      />
      <GoogleReviews />
      <Press />
      <Box height="80px" backgroundColor="white" />
    </Head>
  );
};

export default NewHome;
